import { Body } from "@growtherapy/sprout-ui";
import { LoadingSpinner } from "../../components/LoadingSpinner";

export function JoiningClientLoader() {
  return (
    <div className="flex gap-2 items-center text-small">
      <LoadingSpinner aria-hidden />
      <Body.Small>Waiting for client to join</Body.Small>
    </div>
  );
}
